import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { Sheet } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';

import { useManagerFilterProps } from '@app/pages/Prototype/NftManagerPanel/hooks';

import { FiltersListToggle } from '../../../FiltersListToggle';

import { FiltersList, FiltersListModal } from './components';

type FilterSidebarProps = {
    showSidebar: boolean;
    handleSidebarClose: () => void;
    handleSidebarOpen: () => void;
    handleSidebarToggle: () => void;
};

export function FilterSidebar({
    showSidebar,
    handleSidebarClose,
    handleSidebarOpen,
    handleSidebarToggle,
}: FilterSidebarProps) {
    const { tablet } = useMediaQuery();
    const { onClearFilters, filterListMarkup, showFilters, filtersCount } = useManagerFilterProps();

    if (!showFilters) return null;

    return (
        <AnimatePresence initial={false} mode={!tablet ? 'wait' : 'sync'}>
            {!tablet && (
                <FiltersListToggle
                    removeNavigationBottomSpacing
                    mobile
                    count={filtersCount}
                    open={showSidebar}
                    onToggle={handleSidebarToggle}
                />
            )}

            {showSidebar &&
                filterListMarkup &&
                (tablet ? (
                    <Sheet.Layout.Columns.Secondary key="FilterSidebar-Columns-Secondary" padded scrollable>
                        <FiltersList filterList={filterListMarkup} />
                    </Sheet.Layout.Columns.Secondary>
                ) : (
                    <FiltersListModal
                        onClearFilters={onClearFilters}
                        filterList={filterListMarkup}
                        open={showSidebar}
                        onClose={handleSidebarClose}
                        onSubmit={handleSidebarOpen}
                    />
                ))}
        </AnimatePresence>
    );
}
